import * as z from "zod/mini";
import { parseFrameConfig, themeBaseSchema } from "../../lib/parse-frame-config";

const publicSchema = z.extend(themeBaseSchema, {
  channelId: z._default(z.string(), ""),
  // Optional. When present it's forwarded on the frame URL so the edge can resolve the partner
  // (frame-ancestors CSP) from the token's publishable-key claim; the frame needs no session itself.
  clientToken: z._default(z.string(), ""),
});

const devSchema = z.object({});

const KNOWN_KEYS = new Set([...Object.keys(publicSchema.shape), ...Object.keys(devSchema.shape)]);

export type FrameConfig = z.infer<typeof publicSchema>;

export function parseConfig(search?: string): FrameConfig {
  const { config } = parseFrameConfig({
    publicSchema,
    devSchema,
    knownKeys: KNOWN_KEYS,
    search,
  });
  return config;
}
